import React from 'react';
import { ThemeProvider } from 'styled-components';

import { InputWrapper, Label, InputContainer, StyledInput, IconWrapper } from './input.styles';

const Input = ({
  label,
  type = 'text',
  placeholder,
  value,
  onChange,
  icon,
  iconSize,
  name,
  id,
  disabled,
  ...props
}) => {
  return (
    <InputWrapper>
      {label && <Label htmlFor={id || name}>{label}</Label>}
      <InputContainer>
        <StyledInput
          type={type}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          name={name}
          id={id || name}
          disabled={disabled}
          {...props}
        />
        {icon && <IconWrapper iconSize={iconSize}>{icon}</IconWrapper>}
      </InputContainer>
    </InputWrapper>
  );
};

export default Input;
